import React from "react";
import type { Certification } from "../types";
import type { SustainabilityMetricEmitter } from "../../../../sdk/metrics";
import { getMediaCentralUrl } from "../services/media-service";

interface CertificationDetailViewProps {
  certification: Certification;
  className?: string;
  metricEmitter?: SustainabilityMetricEmitter;
}

export const CertificationDetailView: React.FC<
  CertificationDetailViewProps
> = ({ certification, className = "", metricEmitter }) => {
  const handleLearnMoreClick = () => {
    metricEmitter?.trackClick("lm");
  };

  return (
    <div className={`certification-detail-view ${className}`}>
      <div className="certification-detail-view__content">
        <div className="certification-detail-view__header">
          {certification.icon && (
            <img
              src={getMediaCentralUrl(
                certification.icon.physicalId,
                certification.icon.extension,
                true,
              )}
              alt=""
              className="certification-detail-view__icon"
              aria-hidden="true"
            />
          )}
          <h2 className="certification-detail-view__title">
            {certification.displayName}
          </h2>
        </div>

        <p className="certification-detail-view__description">
          {certification.description}
        </p>

        {certification.learnMoreLink && (
          <p
            className={`certification-detail-view__learn-more ${
              (certification.displayDetails?.length ?? 0) > 0
                ? "certification-detail-view__learn-more--has-details"
                : ""
            }`}
          >
            <a
              href={certification.learnMoreLink.url}
              className="certification-detail-view__learn-more-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleLearnMoreClick}
              aria-label={
                certification.learnMoreLink.data.ariaLabel ||
                certification.displayName
              }
            >
              {certification.learnMoreLink.data.ariaLabel}
            </a>
          </p>
        )}

        {(certification.displayDetails?.length ?? 0) > 0 && (
          <div className="certification-detail-view__details">
            <div className="certification-detail-view__details-list">
              {certification.displayDetails!.map((detail, index) => (
                <div
                  key={index}
                  className="certification-detail-view__detail-row"
                >
                  <h3 className="certification-detail-view__detail-heading">
                    {detail.heading}
                  </h3>
                  <span className="certification-detail-view__detail-value">
                    {detail.value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
